<template>
  <div>
    <div v-html="splittedText"></div>
  </div>
</template>

<script>
  export default {
    props: {
      item: { required: true },
      searchText: { required: true }
    },

    computed: {
      splittedText() {
        const fromIndex = this.item.text.indexOf(this.searchText);
        const toIndex = fromIndex + this.searchText.length;

        let splittedText = {
          left: this.item.text.substring(0, fromIndex),
          middle: "<b>" + this.item.text.substring(fromIndex, toIndex) + "</b>",
          right: this.item.text.substring(toIndex)
        };

        return splittedText.left + splittedText.middle + splittedText.right;
      }
    }
  }
</script>